import React from "react";

export const Line = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="true"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 19 19"
    >
      <path
        d="M95 110C52 66 19 27 23 23c8-7 167 145 167 159 0 19-20 3-95-72z"
        transform="matrix(.1 0 0 -.1 0 21)"
      />
    </svg>
  );
};
